import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';

export default function Personal({ handleUpdate, client }) {
  return (
    <>
      {client.attr('isPrimary') !== 'true' && (
        <MetaControl
          attrName="relationship"
          onChange={value => handleUpdate(client.attr('relationship', value))
          }
          resource={client}
          test={'client-card-personal-first-name-input'}
        />
      )}
      <MetaControl
        attrName="firstName"
        onChange={value => handleUpdate(client.attr('firstName', value))}
        resource={client}
      />
      <MetaControl
        attrName="lastName"
        onChange={value => handleUpdate(client.attr('lastName', value))}
        resource={client}
      />
      {client.type() === 'client' && (
        <MetaControl
          attrName="nickname"
          onChange={value => handleUpdate(client.attr('nickname', value))}
          resource={client}
        />
      )}
      <MetaControl
        attrName="birthDate"
        openTo="year" // TODO: Make meta override. Do not duplicate pattern.
        onChange={value => handleUpdate(client.attr('birthDate', value))}
        resource={client}
      />
      {client.attr('relationship') === 'spouse' && (
        <MetaControl
          attrName="anniversaryDate"
          openTo="year"
          onChange={value => handleUpdate(client.attr('anniversaryDate', value))}
          resource={client}
        />
      )}
    </>
  );
}

Personal.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};
